// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import SignInResetPasswordForm from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import xHeaderUpdate from "@werner/App/Handlers/XNG/Header";
import { CustomAppState } from "@werner/App/Store/Reducers";
import Modal, { ModalPresentationProps } from "@werner/MobiusOverrides/Modal/Modal";
import { signInExistingAccountStyles } from "@werner/Overrides/Widgets/SignIn/SignInExistingAccount";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    return {
        resetPasswordModalOpen: state.xHeader.isResetPasswordModalOpen,
    };
};

const mapDispatchToProps = {
    xHeaderUpdate,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ResetPasswordModal: FC<Props> = ({ resetPasswordModalOpen, xHeaderUpdate }) => {
    // WESS-902: Solution for Contact Us Page - Reset Password Custom Widget (Rich Content)
    React.useEffect(() => {
        const addClickHandle = () => {
            setTimeout(() => {
                const modalTriggers = document.getElementsByClassName("forgot-password-trigger") || [];
                for (const btn of modalTriggers) {
                    if (!btn) {
                        continue;
                    }
                    (btn as any).onclick = () => {
                        if (!resetPasswordModalOpen) {
                            xHeaderUpdate({ key: "isResetPasswordModalOpen", value: true });
                        }
                    };
                }
            }, 100);
        };
        // Event initialization for page load/reload/refresh
        addClickHandle();
        // Event delegation for page/component change
        const observer = new MutationObserver(() => {
            addClickHandle();
        });
        // Attach observer to <main>
        observer.observe(document, {
            childList: true,
            subtree: true,
        });

        // Disconnect observer when component unmounts
        return () => {
            observer.disconnect();
        };
    }, []);

    const onResetPasswordClose = () => {
        xHeaderUpdate({ key: "isResetPasswordModalOpen", value: false });
    };

    return (
        <Modal
            headline={translate("Reset Password")}
            {...signInExistingAccountStyles.resetPasswordModal}
            isOpen={resetPasswordModalOpen}
            handleClose={() => onResetPasswordClose()}
            data-test-selector="resetPasswordModal"
        >
            <SignInResetPasswordForm onClose={() => onResetPasswordClose()} />
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordModal);
